import React from 'react';

import { ContainerHeader, TabContainer } from '~components';
import { faMoneyBill } from '~components/icon';

import { CoContributions } from './index';

const CoContributionsContainer: React.FC = () => {
  const tabs = [{ id: 'sah-co-contributions', title: 'Co-Contributions', component: CoContributions }];

  return (
    <div className="p-2">
      <ContainerHeader icon={faMoneyBill} iconSize="1x" className="info" dataCy="sah-co-contributions-header">
        <div className="d-flex align-items-center gap-1">
          <span>Support at Home - Client Co-Contributions</span>
        </div>
      </ContainerHeader>
      <TabContainer tabs={tabs} />
    </div>
  );
};

export default CoContributionsContainer;
